import { render, staticRenderFns } from "./authorization-confirmation.vue?vue&type=template&id=30eb04a8&scoped=true"
import script from "./authorization-confirmation.vue?vue&type=script&lang=js"
export * from "./authorization-confirmation.vue?vue&type=script&lang=js"
import style0 from "./authorization-confirmation.vue?vue&type=style&index=0&id=30eb04a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30eb04a8",
  null
  
)

export default component.exports